import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import categoriesReducer from '../features/categories/categoriesSlice';
import storiesReducer from '../features/stories/storiesSlice';
import tagsReducer from '../features/tags/tagsSlice';
import themeReducer from '../features/theme/themeSlice';
import novelCategoriesReducer from '../features/novelCategories/novelCategoriesSlice';
import novelsReducer from '../features/novels/novelsSlice';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        categories: categoriesReducer,
        stories: storiesReducer,
        tags: tagsReducer,
        theme: themeReducer,
        novelCategories: novelCategoriesReducer,
        novels: novelsReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export default store;

